import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updatePageStatus } from 'redux/actions/ui.action';
import backgroundMyTopic from 'static/svg/bg-topic-detail.svg';
import Section from 'views/components/core/Section';
import './custom-home.scss';
import CardMvpSession from '../../components/core/CardSession';
import { getCategorySessions, getMyTopics } from 'redux/actions/mvp/session.action';
import { PageHero, PageLoader } from '@kambria/kambria-lego';
import config from 'config';
import { ConfigProvider, Select, DatePicker } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faSearch } from '@fortawesome/free-solid-svg-icons';
import debounce from 'lodash/debounce';
import moment from 'moment';
import _ from 'lodash';
import { I18n } from '../../../helpers/i18n';
import vi_VN from 'antd/es/locale/vi_VN';
import en_US from 'antd/es/locale/en_US';

const locale = I18n.language === 'vi' ? vi_VN : en_US;

class MyTopic extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      totalRecords: 0,
      pageLimit: 40,
      listTopics: [],
      categories: [],
      evaluating: [],
      createDate: [],
      languages: [],
      filterCategories: [],
      filterEvaluating: null,
      filterLanguage: null,
      filterKeySearch: '',
      filterCreateDate: null,
      openFilterCreateDate: false,
      startDate: null,
      endDate: null,
      filterArchiveMulti: [
        { key: 'unarchived', value: 'unarchived', label: I18n.t('filter_archive_status_active') },
      ],
    };
  }

  getArchiveFilterOptions = () => [
    { key: 'unarchived', value: 'unarchived', label: I18n.t('filter_archive_status_active') },
    { key: 'archived', value: 'archived', label: I18n.t('archive') },
  ];

  style = {
    backgroundImage: `url(${backgroundMyTopic})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    minHeight: '1px',
  };
  isOther = () => (this.state.filterCreateDate?.value === 'other')
  async componentDidMount() {
    document.title = `TECD - ${I18n.t('tecd_slogan')}`;
    this.props.updatePageStatus('loading');
    setTimeout(() => {
      this.setState({
        evaluating: [
          { value: 1, key: 1, label: I18n.t('from_one_star') },
          { value: 2, key: 2, label: I18n.t('from_two_star') },
          { value: 3, key: 3, label: I18n.t('from_three_star') },
          { value: 4, key: 4, label: I18n.t('from_four_star') },
          { value: 5, key: 5, label: I18n.t('five_star') },
        ],
        createDate: [
          { value: 'today', label: I18n.t('today') },
          { value: 'yesterday', label: I18n.t('yesterday') },
          { value: 'thisWeek', label: I18n.t('this_week') },
          { value: 'sevenDaysAgo', label: I18n.t('7_days_ago') },
          { value: 'other', label: I18n.t('range_calendar') },
        ],
      })
    }, 0)
    const { getMyTopics, getCategorySessions } = this.props;
    const params = this.mapUrlToFilter();
    const newState = {};

    let categories = [];
    let sessions = [];

    if (Object.keys(params).length) {
      categories = await getCategorySessions();
    } else {
      [categories, sessions] = await Promise.all([
        getCategorySessions(),
        getMyTopics(params),
      ]);
    }
    if (this.props.listLanguage.length) {
      newState.languages = this.props.listLanguage.map(item => ({
        key: item.value,
        value: item.value,
        label: item.label,
      }))
    }

    categories = categories.map(item => ({
      key: item._id,
      value: item._id,
      label: item.name,
    }));

    const { categoryId, evaluating, keySearch, startDate, endDate, language, isArchive } = params;
    if (categoryId) {
      const cateIds = categoryId.split(',');
      const cateInfo = categories.filter(obj => cateIds.includes(obj.key));
      this.handleSelectMulti(cateInfo, 'filterCategories', I18n.t('session_category_label_required'));
    }

    if (evaluating) {
      const data = this.state.evaluating.find(obj => obj.key === Number(evaluating));
      this.handleSelect(data, 'filterEvaluating', I18n.t('rating'));
    }

    if (language) {
      newState.filterLanguage = language;
    }

    if (keySearch) {
      newState.filterKeySearch = keySearch;
    }

    const archiveOpts = this.getArchiveFilterOptions();
    if (isArchive === 'true') {
      newState.filterArchiveMulti = [archiveOpts[1]];
    } else if (isArchive === 'false') {
      newState.filterArchiveMulti = [archiveOpts[0]];
    }

    if (startDate || endDate) {
      this.handleSelectCreateDate({ value: 'other', label: I18n.t('dashboard_filter_status'), key: 'other' });
      if (startDate) this.handleStartTime(moment(Number(startDate)));
      if (endDate) this.handleEndTime(moment(Number(endDate)));
    }

    if (!categoryId && !evaluating && !keySearch && !language && !isArchive) {
      await this.handleFilter();
    }

    newState.categories = categories;
    if (sessions?.success) {
      newState.listTopics = sessions.data.data.list;
    }

    this.setState(newState, () => {
      this.updateArchiveFilterDisplay();
      this.props.updatePageStatus('loaded');
    });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (this.props.listLanguage !== prevProps.listLanguage) {
      const searchParams = new URLSearchParams(this.props.location.search);
      const language = searchParams.get('language');
      const languages = this.props.listLanguage.map(item => ({
        key: item.value,
        value: item.value,
        label: item.label,
      }))
      this.setState({ languages: languages });
      if (language) {
        const data = languages.find(obj => obj.key === language);
        this.handleSelect(data, 'filterLanguage', I18n.t('language'));
      }
    }

    const { filterCategories, filterEvaluating, filterKeySearch, filterCreateDate, filterLanguage, filterArchiveMulti } = this.state;
    const currentFilters = {
      filterCategories,
      filterEvaluating,
      filterKeySearch,
      filterCreateDate,
      filterLanguage,
      filterArchiveMulti,
    };
    const prevFilters = {
      filterCategories: prevState.filterCategories,
      filterEvaluating: prevState.filterEvaluating,
      filterKeySearch: prevState.filterKeySearch,
      filterCreateDate: prevState.filterCreateDate,
      filterLanguage: prevState.filterLanguage,
      filterArchiveMulti: prevState.filterArchiveMulti,
    };
    const handleToOther = prevState.filterCreateDate !== filterCreateDate && this.isOther()
    if (handleToOther) {
      return
    }
    if (!_.isEqual(currentFilters, prevFilters)) {
      await this.handleChangeDebounced();
    }
  }

  handleDropdownVisibleChange = (open) => {
    setTimeout(() => {
      if (this.isOther() && !open) {
        return
      }
      this.setState({ openFilterCreateDate: open });
    }, 0)
  };

  renderSelectMulti = ({ label, select, options }) => {
    const selectedItems = this.state[select];
    return (
      <Select
        className={select}
        showArrow
        labelInValue
        showSearch={false}
        removeIcon={false}
        mode="multiple"
        value={selectedItems}
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
        placeholder={label}
        onChange={(value) => this.handleSelectMulti(value, select, label)}
        dropdownRender={menu => (
          <>
            <div className="mtp-dropdown-menu">{menu}</div>
            {options && options.length ? (<div className="mtp-dropdown-footer">
              <div className="d-flex">
                <button onClick={(event) => this.handleClearSelect(event, select)} className="clear-all">
                  {I18n.t('clear_all')}
                </button>
                <button onClick={this.handleFilter} className="apply">{I18n.t('apply')}</button>
              </div>
            </div>) : null}
          </>
        )}
        options={options}
      />
    );
  };
  handleStartTime = (value) => {
    const endDate = this.state.endDate?.valueOf() || null;
    if (endDate && endDate < value?.valueOf()) {
      this.setState({startDate: null})
      return
    }
    this.setState({startDate: value}, () => {
      const { filterCreateDate, startDate, endDate } = this.state;
      let title = I18n.t('dashboard_filter_date');
      let element = document.querySelectorAll(`.createDate .ant-select-selector`);
      let spans = element[0].querySelectorAll('.ant-select-selection-item');
      if (spans.length && filterCreateDate && filterCreateDate.value) {
        if (this.isOther()) {
          if (startDate && endDate) {
            title = `${title}: ${moment(startDate).format('DD/MM/YY')} - ${moment(endDate).format('DD/MM/YY')}`;
          } else if (startDate) {
            title = `${I18n.t('date_from')} ${moment(startDate).format('DD/MM/YY')}`;
          } else if (endDate) {
            title = `${I18n.t('date_to')} ${moment(endDate).format('DD/MM/YY')}`;
          }
        } else {
          title = `${title}: ${filterCreateDate.label}`;
        }
        spans[0].innerHTML = title;
        spans[0].setAttribute('title', title);
      }
    })
  }
  handleEndTime = (value) => {
    const startDate = this.state.startDate?.valueOf() || null;
    if (startDate && value?.valueOf() < startDate) {
      this.setState({endDate: null})
      return
    }
    this.setState({endDate: value}, () => {
      const { filterCreateDate, startDate, endDate } = this.state;
      let title = I18n.t('dashboard_filter_date');
      let element = document.querySelectorAll(`.createDate .ant-select-selector`);
      let spans = element[0].querySelectorAll('.ant-select-selection-item');
      if (spans.length && filterCreateDate && filterCreateDate.value) {
        if (this.isOther()) {
          if (startDate && endDate) {
            title = `${title}: ${moment(startDate).format('DD/MM/YY')} - ${moment(endDate).format('DD/MM/YY')}`;
          } else if (startDate) {
            title = `${I18n.t('date_from')} ${moment(startDate).format('DD/MM/YY')}`;
          } else if (endDate) {
            title = `${I18n.t('date_to')} ${moment(endDate).format('DD/MM/YY')}`;
          }
        } else {
          title = `${title}: ${filterCreateDate.label}`;
        }
        spans[0].innerHTML = title;
        spans[0].setAttribute('title', title);
      }
    })
  }
  renderSelectDate = (options) => {
    const { filterCreateDate, openFilterCreateDate, startDate, endDate } = this.state;

    return (
      <Select
        className="createDate"
        showArrow
        labelInValue
        showSearch={false}
        removeIcon={false}
        open={openFilterCreateDate}
        onDropdownVisibleChange={this.handleDropdownVisibleChange}
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
        value={filterCreateDate}
        placeholder={I18n.t('dashboard_filter_date')}
        onChange={this.handleSelectCreateDate}
        dropdownStyle={{ width: '350px' }}
        dropdownRender={menu => (
          <>
            <div className="mtpd-dropdown-menu">{menu}</div>
            {options && options.length ? (
              <div className="mtp-dropdown-footer">
                {this.isOther() && (
                  <ConfigProvider locale={locale}>
                    <div className="d-flex justify-content-center align-content-center">
                      <DatePicker
                        locale={locale}
                        size="small"
                        className="cd-picker"
                        onChange={this.handleStartTime}
                        value={startDate}
                        format={'DD/MM/YYYY'}
                        placeholder={null}
                        suffixIcon={null}
                        separator=" - "
                        allowClear={false}
                      />
                      <div className="d-flex align-items-center mr-2 ml-2" style={{color: '#9CA3AF', fontSize: '16px'}}>-</div>
                      <DatePicker
                        locale={locale}
                        size="small"
                        className="cd-picker"
                        onChange={this.handleEndTime}
                        value={endDate}
                        format={'DD/MM/YYYY'}
                        placeholder={null}
                        suffixIcon={null}
                        separator=" - "
                        allowClear={false}
                      />
                    </div>
                  </ConfigProvider>
                )}
                <div className="d-flex">
                  <button
                    onClick={this.handleClearSelectDate}
                    className="clear-all">{I18n.t('clear_all')}
                  </button>
                  <button onClick={this.handleFilterDate} className="apply">{I18n.t('apply')}</button>
                </div>
              </div>
            ) : null}
          </>
        )}
        options={options}
      />
    );
  };

  renderSelect = ({ label, select, options }) => {
    const selectedItems = this.state[select];
    return (
      <Select
        className={select}
        showArrow
        labelInValue
        showSearch={false}
        removeIcon={false}
        value={selectedItems}
        placeholder={label}
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
        onChange={(value) => this.handleSelect(value, select, label)}
        dropdownRender={menu => (
          <>
            <div className="mtp-dropdown-menu">{menu}</div>
            {options && options.length ? (<div className="mtp-dropdown-footer">
              <div className="d-flex">
                <button onClick={(event) => this.handleClearSelect(event, select)} className="clear-all">{I18n.t('clear_all')}
                </button>
                <button onClick={this.handleFilter} className="apply">{I18n.t('apply')}</button>
              </div>
            </div>) : null}
          </>
        )}
        options={options}
      />
    );
  };

  updateArchiveFilterDisplay = () => {
    const selected = this.state.filterArchiveMulti || [];
    const short = I18n.t('filter_archive_status_label_short');
    const full = I18n.t('filter_archive_status');
    let title = full;
    if (selected.length === 1) {
      title = `${short}: ${selected[0].label}`;
    } else if (selected.length >= 2) {
      title = `${short}: ${I18n.t('filter_archive_status_all')}`;
    }
    const element = document.querySelectorAll('.archiveStatusFilter .ant-select-selector');
    if (!element.length) {
      return;
    }
    const labels = element[0].querySelectorAll('label');
    labels.forEach((span) => span.remove());
    element[0].innerHTML += `<label>${title}</label>`;
  };

  handleArchiveMultiChange = (value) => {
    this.setState({ filterArchiveMulti: value || [] }, () => this.updateArchiveFilterDisplay());
  };

  handleClearArchiveMulti = (event) => {
    if (event) {
      event.preventDefault();
      event.target.blur();
    }
    this.setState({ filterArchiveMulti: [] }, () => this.updateArchiveFilterDisplay());
  };

  renderArchiveStatusSelect = () => {
    const options = this.getArchiveFilterOptions();
    const selectedItems = this.state.filterArchiveMulti || [];
    const placeholder = I18n.t('filter_archive_status');
    return (
      <Select
        className="archiveStatusFilter"
        showArrow
        labelInValue
        mode="multiple"
        showSearch={false}
        removeIcon={false}
        value={selectedItems}
        getPopupContainer={(triggerNode) => triggerNode.parentElement}
        placeholder={placeholder}
        onChange={this.handleArchiveMultiChange}
        menuItemSelectedIcon={
          <FontAwesomeIcon icon={faCheck} style={{ color: '#61E6BD', fontSize: 14 }} />
        }
        dropdownRender={(menu) => (
          <>
            <div className="mtp-dropdown-menu">{menu}</div>
            {options.length ? (
              <div className="mtp-dropdown-footer">
                <div className="d-flex">
                  <button type="button" onClick={this.handleClearArchiveMulti} className="clear-all">
                    {I18n.t('clear_all')}
                  </button>
                  <button type="button" onClick={this.handleFilter} className="apply">
                    {I18n.t('apply')}
                  </button>
                </div>
              </div>
            ) : null}
          </>
        )}
        options={options}
      />
    );
  };

  handleSelect = (value, select, label) => {
    if (!value) {
      this.handleClearSelect(null, select);
      return;
    }
    this.setState({ [select]: value }, () => {
      const selectedItems = this.state[select];
      let title = label;
      let element = document.querySelectorAll(`.${select} .ant-select-selector`);
      let spans = element[0].querySelectorAll('.ant-select-selection-item');
      if (spans.length && selectedItems && selectedItems.value) {
        title = `${label}: ${selectedItems.label}`;
        spans[0].innerHTML = title;
      }
    });
  };

  handleSelectCreateDate = (value) => {
    if (!value) {
      this.handleClearSelectDate(null);
      return;
    }
    const state = { filterCreateDate: value }
    if (value !== 'other') {
      state.startDate = null
      state.endDate = null
    }

    this.setState(state, () => {
      const { filterCreateDate } = this.state;
      let title = I18n.t('dashboard_filter_date');
      let element = document.querySelectorAll(`.createDate .ant-select-selector`);
      let spans = element[0].querySelectorAll('.ant-select-selection-item');
      if (spans.length && filterCreateDate && filterCreateDate.value) {
        title = `${title}: ${filterCreateDate.label}`;
        spans[0].innerHTML = title;
      }
    });
  };

  handleSelectMulti = (value, select, label) => {
    if (!value.length) {
      this.handleClearSelect(null, select);
      return;
    }
    this.setState({ [select]: value }, () => {
      const selectedItems = this.state[select];
      let title = label;
      let element = document.querySelectorAll(`.${select} .ant-select-selector`);
      let spans = element[0].querySelectorAll('label');
      if (spans.length) {
        spans.forEach(span => span.remove());
      }
      if (selectedItems && selectedItems.length) {
        if (selectedItems.length > 1) {
          title = `${label}: ${selectedItems.length} ${I18n.t('choice')}`;
        } else {
          title = `${label}: ${selectedItems[0].label}`;
        }
        if (element.length) {
          element[0].innerHTML += `<label>${title}</label>`;
        }
      }
      element = null;
      spans = null;
    });
  };

  mapUrlToFilter = () => {
    const searchParams = new URLSearchParams(this.props.location.search);
    const categoryId = searchParams.get('categoryId');
    const evaluating = searchParams.get('evaluating');
    const keySearch = searchParams.get('keySearch');
    const startDate = searchParams.get('startDate');
    const endDate = searchParams.get('endDate');
    const language = searchParams.get('language');
    const isArchive = searchParams.get('isArchive');
    return { categoryId, evaluating, keySearch, startDate, endDate, language, isArchive }
  }

  mapFilterToUrl = (params) => {
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (key === 'isArchive') {
        if (params[key] === true || params[key] === false) searchParams.set(key, params[key]);
        else searchParams.delete(key);
      } else if (params[key]) {
        searchParams.set(key, params[key]);
      } else {
        searchParams.delete(key);
      }
    });

    this.props.history.push({ search: searchParams.toString() });
  }

  handleFilter = async (event) => {
    if (event) {
      event.target.blur();
    }

    const { filterEvaluating, filterCategories, filterKeySearch, filterCreateDate, filterLanguage, filterArchiveMulti } = this.state;
    const { getMyTopics } = this.props;

    let categoryId = null;
    if (filterCategories && filterCategories.length) {
      categoryId = filterCategories.map(c => c.value).join(',');
    }
    const evaluating = filterEvaluating?.value || null;
    const language = filterLanguage?.value || null;
    const keySearch = (filterKeySearch || '').trim();
    const archiveSel = filterArchiveMulti || [];
    let isArchive = null;
    if (archiveSel.length === 1) {
      isArchive = archiveSel[0].key === 'archived';
    }
    let startDate, endDate;
    if (filterCreateDate && filterCreateDate.value) {
      const filterDate = this.getStartEndDate(filterCreateDate.value);
      startDate = filterDate.startDate;
      endDate = filterDate.endDate;
    }
    this.mapFilterToUrl({ categoryId, evaluating, keySearch, startDate, endDate, language, isArchive });
    const params = { categoryId, evaluating, keySearch, startDate, endDate, language };
    if (isArchive === true || isArchive === false) params.isArchive = isArchive;
    const sessions = await getMyTopics(params);
    if (sessions.success) {
      const data = sessions.data.data;
      const listTopics = data.list;
      this.setState({
        listTopics,
      });
    }
  };

  handleClearSelect = (event, select) => {
    if (event) {
      event.target.blur();
    }
    this.setState({ [select]: null },() => {
      let element = document.querySelectorAll(`.${select}  .ant-select-selector label`);
      if (element.length) {
        element[0].remove();
      }
      element = null;
    });
  };
  handleFilterDate = async (event) => {
    const {startDate, endDate} = this.state;
    if (this.isOther() && !startDate && !endDate) {
      await this.handleClearSelectDate(null)
    }
    await this.handleFilter(null)
    this.setState({ openFilterCreateDate: false })
  }
  handleClearSelectDate = (event) => {
    if (event) {
      event.target.blur();
    }
    this.setState({
      filterCreateDate: null,
      startDate: null,
      endDate: null,
    });
  };

  handleChangeDebounced = debounce(() => this.handleFilter(null), 500);
  handleSearchChange = async (e) => {
    this.setState({ filterKeySearch: e.target.value });
  };

  getStartEndDate = (date) => {
    if (!date) {
      return { startDate: null, endDate: null };
    }
    let startDate, endDate;
    switch (date) {
      case 'today':
        startDate = moment().startOf('day');
        endDate = moment().endOf('day');
        break;

      case 'yesterday':
        startDate = moment().subtract(1, 'days').startOf('day');
        endDate = moment().subtract(1, 'days').endOf('day');
        break;

      case 'thisWeek':
        startDate = moment().startOf('week').startOf('day');
        endDate = moment().endOf('week').endOf('day');
        break;

      case 'sevenDaysAgo':
        startDate = moment().subtract(7, 'days').startOf('day');
        endDate = moment().subtract(1, 'days').endOf('day');
        break;

      default:
        if (this.state.startDate) {
          startDate = moment(this.state.startDate).startOf('day');
        }
        if (this.state.endDate) {
          endDate = moment(this.state.endDate).endOf('day');
        }
        break;
    }

    return {
      startDate: startDate?.valueOf() || null,
      endDate: endDate?.valueOf() || null
    };
  };

  render() {
    const { listTopics, categories, filterKeySearch, createDate, evaluating, languages } = this.state;
    return (
      <div id="site_wrapper">
        <div className="site-upper">
          {this.props.header}
          <div style={this.style} className="page-hero-cus">
            <PageHero description={I18n.t('my_topic')} />
          </div>
        </div>
        <main className="main">
          <div className="container">
            <PageLoader loading={!listTopics} />
            {listTopics && (
              <Section
                title=""
                url="/"
                className="card-section"
              >
                <div className="mtp-filter-zone">
                  <div className="search">
                    <FontAwesomeIcon className="cursor-pointer" icon={faSearch}
                                     style={{ fontSize: '18px', color: '#9CA3AF' }} />
                    <input value={filterKeySearch} onChange={this.handleSearchChange}
                           placeholder={I18n.t('my_dashboard_topic_search_hint_text')} />
                  </div>
                  <div className="select">
                    {this.renderSelectMulti({
                      label: I18n.t('session_category_label_required'),
                      select: 'filterCategories',
                      options: categories,
                    })}
                    {this.renderSelect({
                      label: I18n.t('rating'),
                      select: 'filterEvaluating',
                      options: evaluating,
                    })}
                    {this.renderSelectDate(createDate)}
                    {this.renderSelect({
                      label: I18n.t('language'),
                      select: 'filterLanguage',
                      options: languages,
                    })}
                    {this.renderArchiveStatusSelect()}
                  </div>
                </div>
                <div className="row">
                  {listTopics.map((item, index) => {
                    return (
                      <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
                        <CardMvpSession
                          key={index}
                          data={item}
                          status={item.status}
                          url={config.sites.bounty}
                          user={this.props.user}
                        />
                      </div>
                    );
                  })}
                </div>
              </Section>
            )}
          </div>
        </main>
        {this.props.footer}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  listLanguage: state.mvp.listLanguage,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getMyTopics,
      updatePageStatus,
      getCategorySessions,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(MyTopic);
